<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-text-field  label="Search" class="px-1"
                       v-model="mocks.search"
                       clearable
                       flat dense
                       solo-inverted
                       hide-details
                       prepend-inner-icon="mdi-magnify"
                       @input="$router.replace({name: $route.name, query: {...$route.query, search: mocks.search}})"

        ></v-text-field>
      </template>
    </v-toolbar>
    <v-toolbar class="box-shadow">
      <v-select label="Tutor" class="px-1"
                :items="tutors"
                v-model="mocks.tutor"
                item-value="id"
                item-text="nickname"
                clearable dense solo-inverted hide-details
                @change="$router.replace({name: $route.name, query: {...$route.query, tutor: mocks.tutor}})"
      />

      <v-select label="Practice area" class="px-1"
                :items="practice_areas"
                v-model="mocks.practice_area"
                item-value="id"
                item-text="name"
                clearable dense solo-inverted hide-details
                @change="$router.replace({name: $route.name, query: {...$route.query, practice_area: mocks.practice_area}})"
      />
      <v-select label="Session type" class="px-1"
                :items="session_types"
                v-model="mocks.session_type"
                item-value="id"
                item-text="name"
                clearable dense solo-inverted hide-details
                @change="$router.replace({name: $route.name, query: {...$route.query, session_type: mocks.session_type}})"
      />

      <v-btn color="primary" class="box-shadow px-1" @click="openCreateDialog">Create new</v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-data-table
          :headers="mocks.headers"
          :items="mock_items"
          :search="mocks.search"
          class="elevation-2"
      >
        <template v-slot:item.tutors="{value}">
          <template v-for="(tutor) in value">
            {{ tutor.nickname }},
          </template>
        </template>
        <template v-slot:item.children="{value}">
          <div v-for="(item, idx) in value" :key="idx" class="py-1">
            <v-hover v-slot="{ hover }">
              <v-chip :color="hover ? 'success' : 'primary'" :class="hover ? 'box-shadow':''" :to="{name: 'Mock edit', params: {mock_id: item.id}}">
                <v-icon left>mdi-label</v-icon>
                {{ item.short_name}}</v-chip>
            </v-hover>
          </div>
        </template>

        <template v-slot:item.actions="{item}">
          <v-btn small color="primary" class="box-shadow"
                 :to="{name: 'Mock edit', params: {mock_id: item.id}}">
            Edit
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="create_item_dialog" @click:outside="closeCreateDialog" max-width="800px">
      <v-form class="text-center" @submit="createMock">
        <v-card v-if="create_item">
          <v-toolbar dark color="primary" dense>
            <v-btn icon dark @click="closeCreateDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            Create mock
            <v-spacer></v-spacer>
            <v-btn dark text type="submit">Create</v-btn>
          </v-toolbar>

          <v-card-text>
            <v-text-field label="Name" v-model="create_item.name" outlined dense required
                          :error-messages="api_errors['name']"/>

            <v-select label="Parent"
                      :items="available_parents"
                      v-model="create_item.parent_id"
                      item-text="name"
                      item-value="id"
                      :error-messages="api_errors['parent_id']"
                      outlined dense
            >
              <template v-slot:item="{ item }">
                {{ item.name }} / {{ item.practice_area.name }} / {{ item.session_type.name }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.name }} / {{ item.practice_area.name }} / {{ item.session_type.name }}
              </template>
            </v-select>

            <v-select label="Practice area"
                      v-model="create_item.practice_area_id"
                      :items="practice_areas"
                      item-text="name"
                      item-value="id"
                      required outlined dense
                      :error-messages="api_errors['practice_area_id']"
            />

            <v-select label="Session type"
                      v-model="create_item.session_type_id"
                      :items="session_types"
                      item-text="name"
                      item-value="id"
                      required outlined dense
                      :error-messages="api_errors['session_type_id']"
            />

            <v-select label="Tutor"
                      v-model="create_item.tutors"
                      :items="available_tutors"
                      item-text="nickname"
                      item-value="id"
                      hide-selected
                      multiple
                      required outlined dense
                      deletable-chips small-chips
                      :error-messages="api_errors['tutor']"
            >
              <template v-slot:item="{item}">
                <v-chip class="ma-2">{{ item.nickname }}</v-chip>
                {{ item.profile_type }} ({{ item.full_name }})
              </template>
            </v-select>

            <v-toolbar dense flat class="blur">Tutor instruction</v-toolbar>
            <vue-editor id="instruction-editor" v-model="create_item.tutor_instruction"
                        :editor-toolbar="toolbar"></vue-editor>

            <v-toolbar dense flat class="blur">Candidate instruction</v-toolbar>
            <vue-editor id="assignment-editor" v-model="create_item.candidate_instruction"
                        :editor-toolbar="toolbar"></vue-editor>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-space-between">
            <v-btn color="primary" @click="closeCreateDialog">Cancel</v-btn>
            <v-btn color="success" type="submit">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!--    </v-container>-->

    <!--    <v-layout fill-height>-->
    <!--      <v-navigation-drawer right permanent height="100%">-->
    <!--        <v-list-item>-->
    <!--          <v-list-item-content>-->
    <!--            <v-list-item-title class="title">-->
    <!--              Application-->
    <!--            </v-list-item-title>-->
    <!--            <v-list-item-subtitle>-->
    <!--              subtext-->
    <!--            </v-list-item-subtitle>-->
    <!--          </v-list-item-content>-->
    <!--        </v-list-item>-->
    <!--        <v-list-->
    <!--            dense-->
    <!--            nav-->
    <!--        >-->
    <!--        </v-list>-->
    <!--      </v-navigation-drawer>-->
    <!--      <v-card>-->
    <!--        text-->
    <!--      </v-card>-->
    <!--    </v-layout>-->


  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Mocks',
  data: () => ({
    mocks: {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        // { text: 'Short name', value: 'short_name' },
        { text: 'Practice area', value: 'practice_area.name' },
        { text: 'Session type', value: 'session_type.name' },
        { text: 'Tutors', value: 'tutors' },
        { text: 'Children', value: 'children' },
        // { text: 'Document link', value: 'documentLink' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      practice_area: null,
      session_type: null,
      tutor: null,
      search: '',
    },
    tutors: [],

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["image", "link", "formula"],
    ],

    api_errors: [],

    create_item_dialog: false,
    create_item: null,
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    mock_items: function () {
      let items = []

      items.push(...this.mocks.items)

      if(this.mocks.tutor) {
        items = items.filter(item => {
          if(item.tutors.find(tutor => tutor.id === this.mocks.tutor)) return item
        })
      }

      if(this.mocks.practice_area) {
        items = items.filter(item => item.practice_area_id === this.mocks.practice_area)
      }
      if(this.mocks.session_type) {
        items = items.filter(item => item.session_type_id === this.mocks.session_type)
      }

      return items
    },

    available_tutors: function () {
      let items = []
      if(!this.create_item) return items
      if(this.create_item.practice_area_id && this.create_item.session_type_id) {
        items.push(...this.tutors)

        items = items.filter(item => {
          let has_practice_area = item.practice_areas.find(pa => pa.id === this.create_item.practice_area_id)
          let has_session_type = item.session_types.find(st => st.id === this.create_item.session_type_id)
          if(has_practice_area && has_session_type) return item
        })
      }
      return items
    },
    available_parents: function () {
      let mocks = []
      mocks.push(...this.mocks.items)

      if(this.create_item && this.create_item.practice_area_id) {
        mocks = mocks.filter(item => item.practice_area_id === this.create_item.practice_area_id)
      }
      return mocks.filter(item => item.parent_id === null)
          .filter(item => item.session_type.status === 'independent')
    },
  },
  mounted() {
    if(this.$route.query.search) this.mocks.search = this.$route.query.search
    if(this.$route.query.tutor) this.mocks.tutor = parseInt(this.$route.query.tutor)
    if(this.$route.query.practice_area) this.mocks.practice_area = parseInt(this.$route.query.practice_area)
    if(this.$route.query.session_type) this.mocks.session_type = parseInt(this.$route.query.session_type)
    this.loadMocks()
    this.loadTutors()
  },
  methods: {
    loadMocks() {
      this.axios.get(`api/mocks`).then(response => {this.mocks.items = response.data.data})
    },
    loadTutors() {
      this.axios.get(`api/tutors`).then(response => {this.tutors = response.data.data })
    },
    openCreateDialog() {
      this.create_item = {
        name: '',
        parent_id: null,
        practice_area_id: null,
        session_type_id: null,
        tutors: [],
        tutor_instruction: '',
        candidate_instruction: '',
      }
      this.create_item_dialog = true
    },
    closeCreateDialog() {
      this.create_item_dialog = false
      this.create_item = null
    },
    createMock(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post(`api/mocks`, this.create_item)
          .then(({data}) => {
            this.$notify('Success!', 'success')
            this.$router.push({name: 'Mock', params: {mock_id: data.data.id}})
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    }
  },
}
</script>
